const Naira = () => (
    <span className="font-[Roboto] font-[700]">&#8358;</span>
);

export default Naira